import React from 'react';
import { Outlet } from 'react-router-dom';
import '../../style/variables.css';
import '../../style/base.css';

/**
 * MarketingLayout wraps public-facing marketing pages (Home, Privacy, etc.)
 * It applies the .marketing-theme class which activates the scoped styles 
 * defined in variables.css and base.css.
 */
const MarketingLayout = () => {
  return (
    <div className="marketing-theme">
      <Outlet />
    </div>
  );
};

export default MarketingLayout;
